// extracted by mini-css-extract-plugin
export default {"root":"paCA3Iig"};